var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.832,
    height: 31.007,
    viewBox: "0 0 25.832 31.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23c95d",
    d: "M16.145,31.007a1.939,1.939,0,0,1-1.937-1.937V24.549H11.624V29.07a1.937,1.937,0,1,1-3.874,0V24.484a3.241,3.241,0,0,1-2.584-3.165V10.986a.646.646,0,0,1,.646-.646H20.02a.646.646,0,0,1,.646.646V21.319a3.24,3.24,0,0,1-2.583,3.165V29.07A1.94,1.94,0,0,1,16.145,31.007Zm7.75-7.75a1.94,1.94,0,0,1-1.938-1.937V12.277a1.938,1.938,0,0,1,3.875,0v9.042A1.939,1.939,0,0,1,23.9,23.256Zm-21.958,0A1.939,1.939,0,0,1,0,21.319V12.277a1.938,1.938,0,0,1,3.875,0v9.042A1.94,1.94,0,0,1,1.937,23.256ZM20.02,9.049H5.812A.647.647,0,0,1,5.166,8.4,6.793,6.793,0,0,1,8.221,2.684L6.648,1.108A.646.646,0,0,1,7.561.2L9.4,2.03a8.845,8.845,0,0,1,7.042,0L18.272.2l.011-.011.005,0a.646.646,0,1,1,.9.928L17.612,2.684A6.792,6.792,0,0,1,20.666,8.4.647.647,0,0,1,20.02,9.049ZM16.145,5.174a.646.646,0,1,0,.646.646A.646.646,0,0,0,16.145,5.174Zm-6.458,0a.646.646,0,1,0,.646.646A.647.647,0,0,0,9.687,5.174Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLg);
export default __webpack_public_path__ + "static/media/android-lg.c6cf268e.svg";
export { ForwardRef as ReactComponent };